export const SBOTD_KEY = 'Online Exclusive Special Buy of the Day';
export const SBOTW_KEY = 'Online Exclusive Pro Special Buy of the Week';
export const DAILY_DEALS_KEY = 'Daily Deal';
export const BOGO = 'BOGO';
export const BMSM = 'BMSM';
export const MSB = 'MSBONLINE';
export const BUY_ONE_GET_ONE_FREE = 'buyOneGetOne';

export const SPECIAL_BUYS = {
  [SBOTD_KEY]: {
    text: 'Special Buy ends in',
    link: '/SpecialBuy/SpecialBuyOfTheDay',
    description: 'Shop All Special Buy of the Day'
  },
  [SBOTW_KEY]: {
    text: 'Special Buy ends in',
    link: '/SpecialBuy/ProSpecialBuyOfTheWeek',
    description: 'Shop All Pro Special Buy of the Week'
  },
  [DAILY_DEALS_KEY]: {
    text: 'Daily Deal ends in',
    link: '/daily-deals',
    description: 'Shop All Daily Deals'
  }
};

export const MESSAGE_KEY = Object.freeze({
  plpMessage: 'plpMessage',
  analyticsMessage: 'analyticsMessage'
});

export const BACKWARDS_BOGO_SUBEXPERIENCE_TAGS = Object.freeze({
  buyOneGetOne: 'buyOneGetOneBackwards',
  buyOneGetPercentageOff: 'buyOneGetPercentageOffBackwards',
  buyOneGetDollarOff: 'buyOneGetDollarOffBackwards',
  buyOneGetY: 'buyOneGetYBackwards',
  buyOneGetYPercentageOff: 'buyOneGetYPercentageOffBackwards',
  buyOneGetYDollarOff: 'buyOneGetYDollarOffBackwards',
  buyXGetOne: 'buyXGetOneBackwards',
  buyXGetOnePercentageOff: 'buyXGetOnePercentageOffBackwards',
  buyXGetOneDollarOff: 'buyXGetOneDollarOffBackwards',
  buyXGetY: 'buyXGetYBackwards',
  buyXGetYPercentageOff: 'buyXGetYPercentageOffBackwards',
  buyXGetYDollarOff: 'buyXGetYDollarOffBackwards',
});

export const DOLLAR_THRESHOLD_BOGO_SUBEXPERIENCE_TAGS = Object.freeze({
  buyMinAmountGetOne: 'buyMinAmountGetOne',
  buyMinAmountGetDollarOff: 'buyMinAmountGetDollarOff',
  buyMinAmountGetPercentageOff: 'buyMinAmountGetPercentageOff'
});

export const EXPERIENCE_TAGS = Object.freeze({
  BOGO: 'BOGO',
  BMSM: 'BMSM',
  MSB: 'MSB',
  BUNDLE: 'BUNDLE'
});

export const FORWARDS_BOGO_SUBEXPERIENCE_TAGS = Object.freeze({
  buyOneGetOne: 'buyOneGetOne',
  buyOneGetPercentageOff: 'buyOneGetPercentageOff',
  buyOneGetDollarOff: 'buyOneGetDollarOff',
  buyOneGetY: 'buyOneGetY',
  buyOneGetYPercentageOff: 'buyOneGetYPercentageOff',
  buyOneGetYDollarOff: 'buyOneGetYDollarOff',
  buyXGetOne: 'buyXGetOne',
  buyXGetOnePercentageOff: 'buyXGetOnePercentageOff',
  buyXGetOneDollarOff: 'buyXGetOneDollarOff',
  buyXGetY: 'buyXGetY',
  buyXGetYPercentageOff: 'buyXGetYPercentageOff',
  buyXGetYDollarOff: 'buyXGetYDollarOff',
  buyThePairAndSave: 'buyThePairAndSave'
});

export const MSB_SUBEXPERIENCE_TAGS = Object.freeze({
  MSB1: 'MSB1',
  MSB2: 'MSB2',
  MSB3: 'MSB3',
  MSB4: 'MSB4',
  MSB5: 'MSB5',
  MSB6: 'MSB6',
  MSB7: 'MSB7',
});

export const BMSM_SUBEXPERIENCE_TAGS = Object.freeze({
  BMSM1Categorized: 'BMSM1Categorized',
  BMSM2Categorized: 'BMSM2Categorized',
  BMSM3Categorized: 'BMSM3Categorized',
  BMSM4Categorized: 'BMSM4Categorized',
  BMSM5Categorized: 'BMSM5Categorized',
  BMSM6Categorized: 'BMSM6Categorized',
  BMSM7Categorized: 'BMSM7Categorized'
});

export const MESSAGE_NUMBER_WORD_MAP = Object.freeze({
  0: 'Zero',
  1: 'One',
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
  9: 'Nine',
  10: 'Ten',
});

export const MESSAGE_PLURAL = Object.freeze({
  none: 'none', // exactly 0
  one: 'one', // exactly 1
  two: 'two', // exactly 2
  many: 'many', // more than 2
  other: 'other' // default if none others are true / defined
});

export const FEATURE_SWITCH_KEYS = {
  pipHiddenPromotionTypes: 'fs:pip-hidden-promotion-types',
  plpPromoMessageEnabled: 'fs:promotion--plpPromoMessageEnabled',
  bxg1Enabled: 'fs:promotion-products--bxg1Enabled',
  isUrgencyMessageEnabled: 'fs-prop:isUrgencyMessageEnabled',
  isDailyDealsEnabled: 'fs:pricing--isDailyDealsEnabled',
};

export const CONDITIONAL_PROMO_PAGES = ['PLP', 'PEP'];
